import { render, staticRenderFns } from "./ReturnStationList.vue?vue&type=template&id=6d80f0f1&lang=pug"
import script from "./ReturnStationList.vue?vue&type=script&lang=ts"
export * from "./ReturnStationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports